// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1Oa-U","tab":"Tabs_tab__3h0AG","tabActive":"Tabs_tabActive__2JLM8"};